
<template>
  <Layout class="doc-container">
    <!-- 左侧树形目录 -->
    <Sider hide-trigger width="350" class="doc-sider">
      <!-- <div class="tree-header">
        <Input search placeholder="搜索文档..." v-model="searchText" @on-search="handleSearch"/>
      </div> -->
      <Tree 
        :data="treeData" 
        @on-select-change="handleNodeSelect"
        :render="renderTreeNodes"
        class="doc-tree"></Tree>
    </Sider>

    <!-- 主内容区 -->
    <Content class="doc-content">
      <Card>
        <div class="doc-header">
          <h1>{{ currentDoc.title }}</h1>
          <!-- <div class="doc-actions">
            <ButtonGroup>
              <Button icon="md-create" @click="editDoc">编辑</Button>
              <Button icon="md-share-alt" @click="shareDoc">分享</Button>
              <Button icon="md-bookmark" @click="bookmarkDoc">收藏</Button>
            </ButtonGroup>
          </div> -->
        </div>
        <div class="doc-body">
          <div v-for="(section, index) in currentDoc.sections" :key="index">
            <!-- <h2 :id="'section-'+index">{{ section.title }}</h2> -->
            <div v-html="section.content"></div>
          </div>
        </div>
      </Card>
    </Content>

    <!-- 右侧目录导航 -->
    <!-- <Affix :offset-top="60" class="doc-affix">
      <Anchor :offset-top="60" show-ink>
        <AnchorLink 
          v-for="(section, index) in currentDoc.sections" 
          :key="index" 
          :href="'#section-'+index" 
          :title="section.title" />
      </Anchor>
    </Affix> -->
  </Layout>
</template>

<script>
export default {
  data() {
    return {
      searchText: '',
      treeData:[],
      // treeData: [
      //   {
      //     title: '产品文档',
      //     expand: true,
      //     type: 'folder',
      //     children: [
      //       {
      //         title: '用户手册',
      //         id: 'user_guide',
      //         type: 'file',
      //         sections: [
      //           { title: '产品介绍', content: '<p>这里是产品介绍内容...</p>' },
      //           { title: '快速入门', content: '<p>快速开始使用指南...</p>' }
      //         ]
      //       },
      //       {
      //         title: 'API参考',
      //         id: 'api_ref',
      //         type: 'file',
      //         sections: [
      //           { title: '接口说明', content: '<p>API接口详细说明...</p>' }
      //         ]
      //       }
      //     ]
      //   },
      //   {
      //     title: '开发文档',
      //     expand: false,
      //     type: 'folder',
      //     children: [
      //       {
      //         title: '前端规范',
      //         id: 'frontend_standard',
      //         type: 'file',
      //         sections: [
      //           { title: '代码规范', content: '<p>前端代码规范要求...</p>' }
      //         ]
      //       }
      //     ]
      //   }
      // ],
      currentDoc: {
        title: '',
        sections: []
      }
    }
  },
  methods: {
    handleSearch(keyword) {
      this.getInfo(keyword);
      // console.log('搜索:', keyword)
      // 实际项目中这里实现搜索逻辑
    },
    handleNodeSelect(nodes) {
      if (nodes.length > 0 && nodes[0].type === 'file') {
        this.currentDoc = {
          title: nodes[0].title,
          sections: nodes[0].sections || []
        }
      }
    },
    renderTreeNodes(h, { root, node, data }) {
      return h('span', {
        class: {
          'tree-node': true,
          'tree-folder': data.type === 'folder',
          'tree-file': data.type === 'file'
        }
      }, [
        h('Icon', {
          props: {
            type: data.type === 'folder' ? 'ios-folder' : 'ios-document'
          },
          style: {
            marginRight: '8px'
          }
        }),
        h('span', data.title)
      ])
    },
    editDoc() {
      this.$Message.info('进入编辑模式')
    },
    shareDoc() {
      this.$Modal.info({
        title: '分享文档',
        content: '文档链接已复制到剪贴板'
      })
    },
    bookmarkDoc() {
      this.$Message.success('文档已收藏')
    },
       async getInfo(keyword) {
        if(!keyword){
          keyword=''
        }
      
      let res = await this.$commonFun.postProxy('admin/manual/getDocument', {type:2,keyword:keyword})
      this.$commonFun.dealApiResult(res, () => {
        
        this.treeData=res.data
        // console.log(res.data)

          // 默认显示第一个文档
    // const firstDoc = res.data[0]?.children?.[0]
     const firstDoc = res.data[0]
    if (firstDoc) {
      this.currentDoc = {
        title: firstDoc.title,
        sections: firstDoc.sections || []
      }
    }

        // this.$refs.table.getLists();
        // this.$commonFun.successTip(res.msg)
      })
    },
  },
  mounted() {
        this.getInfo()
  
  }
}
</script>

<style lang="less">
.doc-container {
  height: 100vh;
  background: #f5f7f9;
  
  .doc-sider {
    background: #fff;
    padding: 16px;
    box-shadow: 2px 0 8px rgba(0,0,0,.1);
    
    .tree-header {
      margin-bottom: 16px;
    }
    
    .doc-tree {
      .ivu-tree-title {
        padding: 5px;
        border-radius: 4px;
        transition: all .2s;
   display: inline-block; /* 必须转为块级或inline-block */
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
        
        &:hover {
          background: #f0f7ff;
        }
      }
      
      .tree-node {
        display: flex;
        align-items: center;
         white-space: nowrap;
  
      }
      
      .tree-folder {
        font-weight: bold;
      }
    }

    ul li {
        word-wrap: break-word!important; /* 允许在单词内换行 */
    }
  }
  
  .doc-content {
    padding: 24px 40px;
    max-width: 800;
    margin: 0 auto;
    
    .doc-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      padding-bottom: 16px;
      border-bottom: 1px solid #eee;
      
      h1 {
        margin: 0;
        font-size: 28px;
      }
    }
    
    .doc-body {
      line-height: 1.8;
      
      h2 {
        margin: 24px 0 16px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
      }
      
      pre {
        background: #f8f8f8;
        padding: 16px;
        border-radius: 4px;
        overflow-x: auto;
      }
    }
  }
  .doc-body  img{
    max-width: 100%;
    max-width: 100%;
  }
  
  .doc-affix {
    width: 180px;
    padding-left: 20px;
    
    .ivu-anchor-link {
      padding: 6px 0;
    }
  }
}
.tree-node > span{
  font-size: 17px;

}



</style>
